<template>
  <div class="container">
    <div class="handle-container">
      <div class="search-container">
        可拖拽调整位置
      </div>
      <div class="btn-style">
        <Button type="primary" icon="md-add" @click="openModal"
          >添加事件</Button
        >
      </div>
    </div>
    <div class="table-container">
      <Table
        :columns="columns"
        :data="eventRules"
        draggable
        @on-drag-drop="hagndleDrop"
      >
        <template slot-scope="{ row }" slot="rule">
          <div v-for="(item, index) in row.conditions" :key="index">
            <span style="color: #2196f3">条件{{ index + 1 }}：</span>
            <span v-for="(condition, i) in item" :key="i">
              {{ getConditionLabel(condition) }};
            </span>
          </div>
        </template>
        <template slot-scope="{ row }" slot="action">
          <span>
            {{
              {
                hangup: "挂机",
                hmc: "触发协同提醒",
                sms: "发送短信",
                api: "接口调用",
              }[row.action]
            }}
            {{
              row.action === "api"
                ? `：${(apiSettings[row.action_data] &&
                    apiSettings[row.action_data].name) ||
                    ""}`
                : ""
            }}
            {{
              row.action === "hmc"
                ? `：${skillMap[row.action_data] || ""}`
                : ""
            }}
          </span>
        </template>
        <template slot-scope="{ row, index }" slot="option">
          <span class="edit-style" @click="handleEdit(row, index)">编辑</span>
          <Poptip
            confirm
            title="确认要删除这条数据吗？"
            @on-ok="delEventRule(index)"
            transfer
          >
            <span class="del-style">删除</span>
          </Poptip>
        </template>
      </Table>
    </div>
    <!-- <var-modal v-model="showRuleModal" @onSubmit="editVar" :curRule="curRule"/> -->
    <rule-modal
      v-model="showRuleModal"
      :curEventRule="curEventRule"
      @onCancel="curEventRule = undefined"
      @onSubmit="editRule"
    />
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import RuleModal from "./components/ruleModal.vue";
import { getUserSkillListA } from '@/server/api'

export default {
  components: {
    RuleModal,
  },
  data() {
    return {
      showRuleModal: false,
      curEventRule: undefined,
      columns: [
        { title: "序号", width: 80, type: "index" },
        { title: "触发条件", slot: "rule" },
        { title: "动作", slot: "action" },
        { title: "只执行一次", key: "first_valid" },
        { title: "操作", slot: "option" },
      ],
      operator: {
        gt: "大于",
        lt: "小于",
        gte: "大于等于",
        lte: "小于等于",
        equals: "等于",
        all: "包含所有",
        any: "包含任一",
      },
      skillMap: {}
    };
  },
  computed: {
    ...mapState("eventRules", ["eventRules"]),
    ...mapState("setting", ["sysVars", "ratings", "apiSettings"]),
    ...mapState("intents", ["intents"]),
  },
  methods: {
    ...mapActions("eventRules", [
      "setEventRule",
      "delEventRule",
      "modifyPosition",
    ]),
    openModal() {
      this.showRuleModal = true;
    },
    editRule(eventRule) {
      this.setEventRule(eventRule);
    },
    handleEdit(eventRule, index) {
      this.curEventRule = { ...eventRule, index };
      this.openModal();
    },

    getConditionLabel(condition) {
      const { rule = "", op, value } = condition;
      let varName = rule.split(":")[1];
      if (rule.indexOf("sys:") === 0) {
        const sysVar = this.sysVars.find((sysVar) => sysVar.id === varName);
        varName = sysVar?.name;
      } else if (rule.indexOf("intent") === 0) {
        const intentId = rule.slice(4);
        const intent = this.intents.find((intent) => intent.id === varName);
        varName = `${intent?.name || ""} 次数`;
      }
      return `${varName} ${this.operator[op]} ${value}`;
    },
    hagndleDrop(originalP, newP) {
      this.modifyPosition({ originalP, newP });
    },
    // 获取技能列表
    async getSkillList() {
      try {
        const response = await getUserSkillListA()
        if (response.code !== 200 || !response.data) return
        this.skillMap = response.data.reduce((acc, cur) => {
          return { ...acc, [cur.id]: cur.name }
        }, {})
      } catch (error) {
        this.$Message.error('获取技能列表失败')
        console.error('获取技能列表错误:', error)
      }
    },
  },
  mounted() {
    this.getSkillList()
  },
};
</script>
<style lang="scss" scoped>
.container {
  width: 100%;
  padding: 20px;
  background-color: #fff;
  .handle-container {
    width: 100%;
    display: flex;
    justify-content: space-between;
    .btn-style {
      display: flex;
      justify-items: flex-start;
      div {
        padding: 10px 20px;
        border-radius: 20px;
        font-size: 14px;
        color: #fff;
      }
      .add-style {
        background-color: #ffa800;
        margin-right: 10px;
      }
      .export-style {
        background-color: #6186cf;
      }
      i {
        font-size: 18px;
      }
    }
  }
  .table-container {
    padding: 20px 0;
  }
  .del-style {
    color: #e72e2e;
    cursor: pointer;
  }
  .edit-style {
    display: inline-block;
    color: #6186cf;
    padding-right: 20px;
    cursor: pointer;
  }
}
</style>
